import Vue from "vue";
import Router from "vue-router";
import store from "@/store";

import Home from "@/modules/home/index.vue";
import Category from "@/modules/categories/index.vue";
import Card from "@/modules/card/index.vue";
import About from "@/modules/about/index.vue";
import paymentMethods from "@/modules/payment-methods/index.vue";
import deliveryMethods from "@/modules/delivery-methods/index.vue";
import Profile from "@/modules/profile/index.vue";
import ProfileInfo from "@/modules/profile/pages/info/index.vue";
import activeOrder from "@/modules/profile/pages/old/active-order/index.vue";
import archiveOrder from "@/modules/profile/pages/old/archive-order/index.vue";
import profileFavourites from "@/modules/profile/pages/favourite/index.vue";
import Contacts from "@/modules/contacts/index.vue";
import newsDetail from "@/modules/news/pages/detail/index.vue";
import Support from "@/modules/support/index.vue";

const PageNotFound = () => import("@/modules/system/page-not-found/index.vue");
const ServerNotFound = () => import("@/modules/system/server-not-found/index.vue");

Vue.use(Router);

const isAuthenticated = (to, from, next) => {
    if (store.state.auth.isAuthenticated) {
        next();
        return;
    }
    next("/");
};

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "*",
            name: "not-found",
            component: PageNotFound,
        },
        {
            path: "/not-found",
            name: "not-found-page",
            component: PageNotFound,
        },
        {
            path: "/:lang(uk|ru)?/thank-you",
            name: "thank-you",
            component: () => import("./modules/thanks-order/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/refund_terms",
            name: "refund_terms",
            component: () => import("./modules/return-conditions/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/public_offer",
            name: "public_offer",
            component: () => import("./modules/public-offer/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/error-order",
            name: "error-order",
            component: () => import("./modules/error-order/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/faq",
            name: "faq",
            component: () => import("./modules/faq/index.vue"),
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "faq",
                        name: "faq",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/cookie-agreement-information",
            name: "cookie-agreement-information",
            component: () => import("./modules/cookie-agreement/index.vue"),
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "cookieAgreementInformation",
                        name: "cookie-agreement-information",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/sitemap",
            name: "sitemap",
            component: () => import("./modules/site-map/index.vue"),
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "sitemap",
                        name: "sitemap",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/server-not-found", // 500
            name: "server-not-found",
            component: ServerNotFound,
        },
        {
            path: "/:lang(uk|ru)?/basket",
            name: "basket",
            component: () => import("./components/basket/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/:geo(kremenchuk|kyiv|zaporizhzhya)?",
            name: "home",
            component: Home,
        },
        {
            path: "/:lang(uk|ru)?/:geo(kremenchuk|kyiv|zaporizhzhya)?/category/:categorySlug",
            name: "category-page",
            component: () => import("./modules/categories-page/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/top-products",
            name: "top-products",
            component: () => import("./modules/top-products/index.vue"),
        },
        {
            path: "/:lang(uk|ru)?/promotions",
            name: "promotion",
            redirect: "/:lang?/promotions/banners",
            component: () => import("./modules/promotions/index.vue"),
            children: [
                {
                    path: "/:lang(uk|ru)?/promotions/banners",
                    name: "promotion-banners",
                    component: () => import("./modules/promotions/promotion-banners/index.vue"),
                },
                {
                    path: "/:lang(uk|ru)?/promotions/products/:promo",
                    name: "promotion-products",
                    component: () => import("./modules/promotions/promotion-products/index.vue"),
                },
                {
                    path: "/:lang(uk|ru)?/promotions/card/:promo/:slug",
                    name: "promotion-card",
                    component: () => import("./modules/promotions/promotion-card/index.vue"),
                },
            ],
        },
        {
            path: "/:lang(uk|ru)?/:geo(kremenchuk|kyiv|zaporizhzhya)?/sub-category/:categorySlug",
            name: "sub-category",
            component: () => import("./modules/top-products/index.vue"),
        },
        // {
        //     path: '/:lang(uk|ru)?/:geo(kremenchuk|kyiv|zaporizhzhya)?/filter',
        //     name: 'category-filter',
        //     component: () => import('./modules/categories/components/filter/index.vue')
        // },
        {
            path: "/:lang(uk|ru)?/:geo(kremenchuk|kyiv|zaporizhzhya)?/categories/:categorySlug/:filterSlug?",
            name: "categories",
            component: Category,
        },
        {
            path: "/:lang(uk|ru)?/payment-methods",
            name: "payment-methods",
            component: paymentMethods,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "payment-methods",
                        name: "payment-methods",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/delivery-methods",
            name: "delivery-methods",
            component: deliveryMethods,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "delivery-methods",
                        name: "delivery-methods",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/card/:item",
            name: "card",
            component: Card,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "catalogProduct",
                        name: "categories",
                    },
                    {
                        bcDynamic: true,
                        bcModule: "card",
                        bcGetter: "product",
                        name: "card",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/about",
            name: "about",
            component: About,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "aboutUs",
                        name: "about",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/contacts",
            name: "contacts",
            component: Contacts,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "contact",
                        name: "contacts",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/support",
            name: "support",
            component: Support,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "support",
                        name: "support",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/news/:slug",
            name: "news-detail",
            component: newsDetail,
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: true,
                        bcModule: "articles",
                        bcGetter: "articlesItem",
                        name: "news-detail",
                    },
                ],
            },
        },
        {
            path: "/:lang(uk|ru)?/profile",
            name: "profile",
            component: Profile,
            redirect: "/:lang?/profile/info",
            beforeEnter: isAuthenticated,
            children: [
                {
                    path: "/:lang(uk|ru)?/profile/info",
                    name: "profile-info",
                    component: ProfileInfo,
                    meta: {
                        breadcrumbs: [
                            {
                                bcDynamic: false,
                                bcLabel: "home",
                                name: "home",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "profile",
                                name: "profile",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "personalOffice",
                                name: "profile-info",
                            },
                        ],
                    },
                },
                {
                    path: "/:lang(uk|ru)?/profile/active-order",
                    name: "active-order",
                    component: activeOrder,
                    meta: {
                        breadcrumbs: [
                            {
                                bcDynamic: false,
                                bcLabel: "home",
                                name: "home",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "profile",
                                name: "profile",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "active-order",
                                name: "active-order",
                            },
                        ],
                    },
                },
                {
                    path: "/:lang(uk|ru)?/profile/archive-order",
                    name: "archive-order",
                    component: archiveOrder,
                    meta: {
                        breadcrumbs: [
                            {
                                bcDynamic: false,
                                bcLabel: "home",
                                name: "home",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "profile",
                                name: "profile",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "archive-order",
                                name: "archive-order",
                            },
                        ],
                    },
                },
                {
                    path: "/:lang(uk|ru)?/profile/favourites",
                    name: "profile-favourite",
                    component: profileFavourites,
                    meta: {
                        breadcrumbs: [
                            {
                                bcDynamic: false,
                                bcLabel: "home",
                                name: "home",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "profile",
                                name: "profile",
                            },
                            {
                                bcDynamic: false,
                                bcLabel: "favourite",
                                name: "profile-favourite",
                            },
                        ],
                    },
                },
            ],
        },
        {
            path: "/:lang(uk|ru)?/agent-info",
            name: "agent-info",
            component: () => import("./modules/agent-info/index.vue"),
            meta: {
                breadcrumbs: [
                    {
                        bcDynamic: false,
                        bcLabel: "home",
                        name: "home",
                    },
                    {
                        bcDynamic: false,
                        bcLabel: "agentInfo",
                        name: "agent-info",
                    },
                ],
            },
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (to.name === "categories") {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
});

export default router;
